<template>
    <div class="container" id="goods-edit">
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>

        <!-- 面包屑导航 -->
        <div class="content c-top">
            <div style="display: flex;margin-top: 20px;">
                <div class="title-l">会员设置</div>
                <div class="title-c">/</div>
                <div class="title-r">{{ title }}</div>
            </div>
            <div class="title">层级设置</div>
            <div>
                <el-form ref="cuponForm1" :model="form" label-width="100px" :rules="rules">
                    <el-form-item label="层级名称" prop="name">
                        <el-input style="width:442px" v-model="form.name" placeholder="请输入层级名称" maxlength="10"
                            show-word-limit clearable></el-input>
                    </el-form-item>
                    <el-form-item label="会员卡背景" prop="bgImg">
                        <upload-picture style="margin-top: 10px;" :imageUrl="form.bgImg" :width="300" :height="108"
                            @getUrl="getImage($event, 'bgImg')"></upload-picture>
                        <div style="color:#999999">图片尺寸：建议上传698px*264px，每张上传大小不得超过2M,支持jpg、jpeg、png格式</div>
                    </el-form-item>
                    <el-form-item label="会员卡标识" prop="logoImg">
                        <upload-picture style="margin-top: 10px;" :imageUrl="form.logoImg" :width="108" :height="30"
                            @getUrl="getImage($event, 'logoImg')"></upload-picture>
                        <div style="color:#999999">图片尺寸：建议上传152px*44px，每张上传大小不得超过2M,支持jpg、jpeg、png格式</div>
                    </el-form-item>
                    <el-form-item label="文字颜色">
                        <el-color-picker v-model="form.fontColor"></el-color-picker>
                    </el-form-item>
                </el-form>
            </div>
            <div class="line"></div>
            <div class="title">升级设置</div>
            <div class="s-box">
                <el-form ref="cuponForm2" :model="form" label-width="100px" :rules="rules">
                    <el-form-item label="升级方式" prop="levelUpList">
                        <div style="display: flex;margin-bottom:12px;"
                            v-for="(item, index) in dictionaries.vip_level_up_type" :key="index">
                            <div><el-checkbox v-model="item.checked" /></div>
                            <div class="s-box-l">{{ item.dictName }}</div>
                            <div class="s-box-y" v-if="item.checked">累计消费满</div>
                            <div v-if="item.checked">
                                <el-input v-model="item.amount" style="width: 232px;" @change="changeType">
                                    <div slot="suffix">元</div>
                                </el-input>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="line"></div>
            <div class="title">会员权益</div>
            <div>
                <el-form :model="form" label-width="100px">
                    <el-form-item label="会员日折扣">
                        <div style="display: flex;">
                            <div>
                                <el-input v-model="form.weeklyDiscount" style="width: 232px;">
                                    <div slot="suffix">折</div>
                                </el-input>
                            </div>
                            <div class="info">（订单结算时享受的打折优惠）</div>

                        </div>

                    </el-form-item>
                    <el-form-item label="消费积分赠送">
                        <div style="display: flex;">
                            <div class="s-box-y">消费金额按</div>
                            <div>
                                <el-select v-model="form.pointsMulti">
                                    <el-option v-for="item in dictionaries.vip_level_points_multi" :key="item.dictId"
                                        :label="item.dictName" :value="item.dictId">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="s-box-y" style="margin-left: 8px;">赠送</div>

                        </div>

                    </el-form-item>
                    <el-form-item label="返佣">
                        <div style="display: flex;">
                            <div><el-checkbox v-model="check1" /></div>
                            <div class="s-box-l">一级返佣</div>

                            <div v-if="check1">
                                <el-input v-model="form.commissionRate1" style="width: 232px;">
                                    <div slot="suffix">%</div>
                                </el-input>
                            </div>
                        </div>
                        <div style="display: flex;margin-top: 14px;">
                            <div><el-checkbox v-model="check2" /></div>
                            <div class="s-box-l">二级返佣</div>

                            <div v-if="check2">
                                <el-input v-model="form.commissionRate2" style="width: 232px;">
                                    <div slot="suffix">%</div>
                                </el-input>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="售后天数">
                        <div style="display: flex;">
                            <div>
                                <el-input v-model="form.orderAfterDays" style="width: 232px;">
                                    <div slot="suffix">天</div>
                                </el-input>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="邀新获优惠">
                        <div style="display: flex;">
                            <div class="s-box-y">邀请新用户获得</div>
                            <div>
                                <el-select v-model="form.inviteGetCouponId" filterable clearable>
                                    <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="s-box-y" style="margin-left: 8px;">优惠券</div>

                        </div>

                    </el-form-item>
                </el-form>
            </div>
            <div class="line"></div>
            <div class="title">会员说明</div>
            <div>
                <el-form ref="cuponForm" :model="form" label-width="100px" :rules="rules">
                    <el-form-item label="会员说明" prop="intro">
                        <!-- <el-input style="width:442px" type="textarea" v-model="form.intro" placeholder="请输入会员说明"
                            maxlength="300" show-word-limit clearable></el-input> -->
                        <quill-editor v-model="form.intro" ref="myQuillEditor" :options="editorOption" style="width: 80%;"
                            class="editor"></quill-editor>
                        <div class="bottom" style="display: none">
                            <el-upload class="centerImg" :action="' '" list-type="picture-card" :auto-upload="false"
                                :on-change="handleAvatarChangeIcon" ref="uploadicon">
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div style="height:10px"></div>
        </div>
        <div class="back-btn">
            <el-button type="info" @click="back">取消</el-button>
            <el-button type="primary" @click="save()">保存</el-button>
        </div>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import uploadPicture from '@/components/upload/mallPicture2.vue'
import { quillEditor } from 'vue-quill-editor'
export default {
    components: { breadcrumbTop, breadcrumbSearch, uploadPicture, quillEditor },
    data() {
        return {
            myQuillEditor: {},
            editorOption: {},
            list: [],
            check1: false,
            check2: false,
            check3: false,
            dataList: {
                list: [
                    { title: '用户管理', path: '', type: '0' },
                    { title: '会员管理', path: '', type: '1' },
                    { title: '会员设置', path: '', type: '2' }
                ]
            },
            searchList: {
                list: [
                    { title: '新增会员', path: '', type: '0' }
                ]
            },
            form: {
                name: '',
                weeklyDiscount: '',
                orderAfterDays: '',
                intro: '',
                pointsMulti: '',
                commissionRate1: '',
                commissionRate2: '',
                commissionRate3: '',
                hasCommission1: 0,
                hasCommission2: 0,
                hasCommission3: 0,
                id: '',
                inviteGetCouponId: '',
                levelUpList: [],
                type: '',
                fontColor: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入层级名称', trigger: 'blur' }
                ],
                levelUpList: [
                    { required: true, message: '请选择升级方式', trigger: 'blur' }
                ],
                intro: [
                    { required: true, message: '请输入会员说明', trigger: 'blur' }
                ],
                logoImg: [
                    { required: true, message: '请上传会员卡标识', trigger: 'blur' }
                ],
                bgImg: [
                    { required: true, message: '请上传会员卡背景', trigger: 'blur' }
                ],
            },
            options: [
                {
                    value: '1',
                    label: '1倍积分'
                },
                {
                    value: '2',
                    label: '1.5倍积分'
                },
                {
                    value: '3',
                    label: '2倍积分'
                }
            ],
            dictionaries: {
                vip_level_up_type: [],
                vip_level_points_multi: []
            },
            title: '新增会员',
        }
    },
    created() {
        this.getDictionaries('vip_level_up_type')
        this.getDictionaries('vip_level_points_multi')
        this.getList()
        if (this.$route.query.type == 'add') {
            this.title = '新增会员'
        } else {
            this.title = '编辑会员'
            this.getDetail(this.$route.query.id)
        }
    },
    watch: {
        dictionaries: {
            handler(newVal, oldVal) {
                setTimeout(() => {
                    let arr = []
                    newVal.vip_level_up_type.forEach(item => {
                        if (item.checked == true) {
                            arr.push(item)
                        }
                    })
                    let allDataStatus = arr.every((item) => {
                        return item.amount != ''
                    })
                    console.log(allDataStatus)
                    if (!allDataStatus) {

                        this.form.levelUpList = []
                        // this.$refs.cuponForm2.validateField('levelUpList')
                    } else {
                        this.$refs.cuponForm2.clearValidate('levelUpList')
                    }
                    this.$forceUpdate()
                }, 1000)
            },
            immediate: true,
            deep: true,// 为true，表示深度监听，这时候就能监测到a值变化

        }
    },
    methods: {
        handleAvatarChangeIcon() {

        },
        getImage(val, type) {
            console.log(val)
            if (type == 'logoImg') {
                this.form.logoImg = val
            } else {
                this.form.bgImg = val
            }
        },
        getDetail(id) {
            this.axios.get('/vip/level/get', {
                params: {
                    id: id
                }
            }).then(res => {
                if (res.code == 0) {
                    setTimeout(() => {
                        // res.data.levelUpList.forEach(item => {
                        //     this.dictionaries.vip_level_up_type.forEach(item1 => {
                        //         if (item.levelUpType == item1.dictId) {
                        //             item1.amount = item.amount
                        //             item1.checked = true
                        //         } else {
                        //             item1.checked = false
                        //         }
                        //     })
                        // })
                        this.dictionaries.vip_level_up_type.forEach(item => {
                            res.data.levelUpList.forEach(item1 => {
                                if (item.dictId == item1.levelUpType) {
                                    item.amount = item1.amount
                                    item.checked = true
                                }
                            })
                        })
                        this.$forceUpdate()
                        if (res.data.hasCommission1 == 1) {
                            console.log('cddd')
                            this.check1 = true
                        } else {
                            this.check1 = false
                        }
                        if (res.data.hasCommission2 == 1) {
                            this.check2 = true
                        } else {
                            this.check2 = false
                        }
                        if (res.data.hasCommission3 == 1) {
                            this.check3 = true
                        } else {
                            this.check3 = false
                        }
                        this.form = res.data
                        this.$forceUpdate()
                    }, 500)

                    // this.form.type = res.data.type + ''
                    // this.form.pointsMulti = res.data.pointsMulti + ''
                }
            })

        },
        changeType(val) {
            console.log(6666, val)
            // this.$refs.cuponForm2.validateField('levelUpList')
            // if (val == '') {
            //     this.$nextTick(() => {
            //         this.form.levelUpList = []
            //         // this.$refs.cuponForm2.validateField('levelUpList')
            //     })
            // } else {
            //     this.$refs.cuponForm2.clearValidate('levelUpList')
            // }


        },
        save() {
            console.log(this.form)
            console.log(this.dictionaries.vip_level_up_type)
            this.form.levelUpList = []
            this.dictionaries.vip_level_up_type.forEach(item => {
                if (item.checked == true) {
                    let obj = {
                        levelUpType: item.dictId,
                        amount: item.amount
                    }
                    this.form.levelUpList.push(obj)
                }
            })
            if (this.check1) {
                this.form.hasCommission1 = 1
            } else {
                this.form.hasCommission1 = 0
            }
            if (this.check2) {
                this.form.hasCommission2 = 1
            } else {
                this.form.hasCommission2 = 0
            }
            if (this.check3) {
                this.form.hasCommission3 = 1
            } else {
                this.form.hasCommission3 = 0
            }
            this.$refs['cuponForm2'].validate((valid) => {
                if (valid) {

                }
            })
            this.$refs['cuponForm1'].validate((valid) => {
                if (valid) {

                }
            })
            this.$refs['cuponForm'].validate((valid) => {
                if (valid) {
                    this.axios.post('/vip/level/addOrEdit', this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            })
                            this.$router.go(-1)
                        }
                    })
                }
            })
        },
        getList() {
            this.axios.get('/coupon/getCouponAndNum').then(res => {
                if (res.code == 0) {
                    this.list = res.data
                }
            })
        },
        back() {
            this.$router.go(-1)
        },
        // 获取字典数据
        getDictionaries(type) {
            this.axios.get('/getDictGroup', {
                params: {
                    groupId: type
                }
            })
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        if (type == 'vip_level_up_type') {
                            res.data.forEach(item => {
                                item.checked = false
                                item.amount = null
                            })
                            this.dictionaries[type] = res.data
                        } else {
                            this.dictionaries[type] = res.data
                        }

                    }
                })
        },
    }
}

</script>

<style scoped lang="scss">
::v-deep .el-input__suffix {
    position: absolute;
    top: 0px !important;
    right: 8px !important;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #c0c0cc;
}

.title-l {
    width: 72px;
    height: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #303033;
    line-height: 0px;
}

.title-c {
    width: 7px;
    height: 21px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #303033;
    line-height: 0px;
    margin-left: 6px;
    margin-right: 6px;
}

.title-r {
    width: 64px;
    height: 21px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    color: #303033;
    line-height: 0px;
}

.title {
    width: 56px;
    height: 19px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 14px;
    color: #303033;
    line-height: 0px;
    margin-top: 16px;
}

.line {
    width: 674px;
    height: 0px;
    border: 1px dashed #EBEBFA;
    margin-top: 24px;
    margin-bottom: 24px;
}

.s-box-l {
    width: 56px;
    height: 19px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #303033;
    line-height: 40px;
    margin-left: 4px;
    margin-right: 24px;
}

.s-box-y {
    min-width: 70px;
    height: 19px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #909099;
    line-height: 40px;
    margin-right: 8px;
}

.info {
    width: 196px;
    height: 19px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #909099;
    line-height: 40px;
}

.back-btn {
    width: 30%;
    text-align: left;
    padding-bottom: 20px;

    .el-button {
        width: 184px;
        height: 48px;
        border-radius: 4px;
        font-size: 18px;
    }
}
</style>